<template>
  <div class="saldo-a-favor">
    <h5>Saldos a Favor Emitidos</h5>
    <table class="table table-stripped table-bordered">
      <thead>
      <th>Folio</th>
      <th>Observaciones</th>
      <th>Referencia</th>
      <th>Monto</th>
      </thead>
      <tbody>
      <tr v-for="saldo in saldos">
        <td>{{saldo.folio_saldo}}</td>
        <td>{{saldo.observacion}}</td>
        <td>{{saldo.tipo_referencia === 'nota-credito' ? 'NC-' : 'EN-'}} {{saldo.folio_referencia}}</td>
        <td>{{saldo.monto | currency}}</td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td colspan="3" style="text-align: right; font-weight: bold">Total</td>
        <td style="font-weight: bold">{{total|currency}}</td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: "saldoAFavor",
  computed: {
    saldos() {
      return this.$store.getters.saldosFavor
    },
    total() {
      return this.$store.getters.saldosFavor.reduce((a, b) => a += b.monto, 0)
    }
  }
}
</script>

<style scoped>

</style>
